import * as React from 'react'

export const DownloadSvg = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 15 18" width={15} height={18} aria-hidden={true} {...props}>
    <path d="M14.5 6.13086H10.5V0.130859H4.5V6.13086H0.5L7.5 13.1309L14.5 6.13086ZM0.5 15.1309V17.1309H14.5V15.1309H0.5Z" />
  </svg>
)
export default DownloadSvg
